module.exports = __webpack_public_path__ + "img/help_link.060661e6.svg";